export default __webpack_public_path__ + "static/media/googleCloud.a09d9749.png";